import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface NotificationState {
  count: number;
  chatCount: number;
}

const initialState: NotificationState = {
  count: 0,
  chatCount: 0,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotificationCount: (state, action: PayloadAction<number>) => {
      state.count = action.payload;
    },
    incrementNotificationCount: (state) => {
      state.count += 1;
    },
    decrementNotificationCount: (state) => {
      state.count = Math.max(0, state.count - 1);
    },
    resetNotificationCount: (state) => {
      state.count = 0;
    },
    setChatCount: (state, action: PayloadAction<number>) => {
      state.chatCount = action.payload;
    },
    incrementChatCount: (state) => {
      state.chatCount += 1;
    },
    decrementChatCount: (state) => {
      state.chatCount = Math.max(0, state.chatCount - 1);
    },
    resetChatCount: (state) => {
      state.chatCount = 0;
    },
  },
});

export const {
  setNotificationCount,
  incrementNotificationCount,
  decrementNotificationCount,
  resetNotificationCount,
  setChatCount,
  incrementChatCount,
  decrementChatCount,
  resetChatCount,
} = notificationSlice.actions;

export default notificationSlice.reducer;
